import React, { Component } from "react";
import "./scroll.css";

import { FaAngleDown } from "react-icons/fa";
// var ps = {

//   backgroundColor: 'aqua',
//   // width: '120px',
//   // height: '30px',
//   position: 'fixed',
//   top: '70px',
//   right: '10px',
// };

class ScrollBottomButton extends Component {
  // state = {
  //   intervalId: 0,
  // };

  // scrollStep = () => {
  //   if (window.pageYOffset === 0) {
  //     clearInterval(this.state.intervalId);
  //   }
  //   window.scroll(0, window.pageYOffset + this.props.scrollStepInPx);
  // };

  // scrollToBottom =()=> {
  //   let intervalId = setInterval(this.scrollStep(), this.props.delayInMs);
  //   this.setState({ intervalId: intervalId });
  // }

  scrollToBottom = () => {
    window.scroll(0, 11000);
  };

  render() {
    return (
      <span className="top-scroll" onClick={this.scrollToBottom}>
        <FaAngleDown className="icon-scroll" />
      </span>
    );
  }
}

export default ScrollBottomButton;
